module.exports = [{
      plugin: require('/codebuild/output/src110722742/src/joan-ribo/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-24972665-25"},
    },{
      plugin: require('/codebuild/output/src110722742/src/joan-ribo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
